import { API_BASE_URL_V2 } from "../../api/URL_Header";

export const STATUS_LABELS_AR = {
  Open: "مفتوحة",
  "In Progress": "قيد المعالجة",
  "Waiting for Customer": "بانتظار العميل",
  Resolved: "تم الحل",
  Closed: "مغلقة",
  "Invalid / No Issue Found": "غير صالحة / لا توجد مشكلة",
};

export const PRIORITY_LABELS_AR = {
  Low: "منخفضة",
  Medium: "متوسطة",
  High: "عالية",
  Urgent: "عاجلة",
};

export const ACTIVITY_LABELS_AR = {
  TicketCreated: "إنشاء التذكرة",
  NoteAdded: "ملاحظة داخلية",
  StatusChanged: "تغيير الحالة",
  PriorityChanged: "تغيير الأولوية",
  Assigned: "تعيين",
  Reassigned: "إعادة تعيين",
  TicketResolved: "تم الحل",
  TicketClosed: "إغلاق",
  AttachmentAdded: "إضافة مرفق",
  AttachmentRemoved: "حذف مرفق",
  TicketUpdated: "تحديث التذكرة",
};

export const statusBadgeClass = (status) => {
  switch (status) {
    case "Open":
      return "bg-blue-100 text-blue-800";
    case "In Progress":
      return "bg-amber-100 text-amber-800";
    case "Waiting for Customer":
      return "bg-purple-100 text-purple-800";
    case "Resolved":
      return "bg-green-100 text-green-800";
    case "Closed":
      return "bg-gray-200 text-gray-700";
    case "Invalid / No Issue Found":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-700";
  }
};

export const priorityBadgeClass = (priority) => {
  switch (priority) {
    case "Low":
      return "bg-slate-100 text-slate-700";
    case "Medium":
      return "bg-sky-100 text-sky-800";
    case "High":
      return "bg-orange-100 text-orange-800";
    case "Urgent":
      return "bg-rose-100 text-rose-800";
    default:
      return "bg-gray-100 text-gray-700";
  }
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  return new Date(value).toLocaleString("ar-EG");
};

export const resolveMediaUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
    return path;
  }
  return `${API_BASE_URL_V2}${path.startsWith("/") ? "" : "/"}${path}`;
};

export const normalizePhoneNumber = (phone) => {
  if (!phone) return "";
  let cleaned = String(phone).replace(/\D/g, "");
  if (cleaned.startsWith("20") && cleaned.length >= 12) {
    cleaned = "0" + cleaned.slice(2);
  }
  if (cleaned.startsWith("1") && cleaned.length === 10) {
    cleaned = "0" + cleaned;
  }
  return cleaned;
};

export const isVideoFileType = (fileType = "") =>
  String(fileType).toLowerCase().startsWith("video/");
